import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { approveEstate } from 'services/api/estates-api.service';
import { notification } from 'services/services';
import { QueryKey } from 'common/enums/query-key';
import { BackendError } from 'common/types/errors/backendError';
import { AxiosError } from 'axios';

export default function useApproveEstate(
  options?: Omit<UseMutationOptions<void, AxiosError<BackendError>, string, unknown>, 'mutationFn'>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: approveEstate,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.Estates, 'admin'] });
    },
    onSuccess: () => {
      notification.success('You have successfully approved the estate');
    },
    onError: (e) => {
      notification.error(e?.response?.data?.detail || 'You could not approve estate, try again');
    },
    ...options,
  });
}
